import { getCheckInModalDataFunctionDef } from '@/backend/features/missions/shared/schemas/getCheckInModalDataSchema';
import { defaultFetcherOptions } from '@juvare/missions/ui/utils/defaultFetcherOptions';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWR from 'swr';

export interface UseCheckInModalDataProps {
    accountBadgeNumber?: string;
    missionId?: string;
    shiftId?: string;
}

export const checkInModalFetchKey = 'checkInModalData';

export const useCheckInModalData = ({ accountBadgeNumber, missionId, shiftId }: UseCheckInModalDataProps) => {
    const getCheckInModalDataPlatformFn = useTypedPlatformFunction(getCheckInModalDataFunctionDef);

    const fetchCheckInModalData = (accountBadgeNumber: string, missionId?: string, shiftId?: string) => {
        return getCheckInModalDataPlatformFn({
            accountBadgeNumber,
            missionId,
            shiftId,
        });
    };

    const {
        data: checkInModalData,
        mutate,
        isLoading,
        error,
    } = useSWR(
        [checkInModalFetchKey, accountBadgeNumber, missionId, shiftId],
        async ([, paramsAccountBadgeNumber, paramsMissionId, paramsShiftId]) => {
            return paramsAccountBadgeNumber ? fetchCheckInModalData(paramsAccountBadgeNumber, paramsMissionId, paramsShiftId) : undefined;
        },
        defaultFetcherOptions,
    );

    const fetchData = React.useCallback(async () => {
        await mutate();
    }, [mutate]);

    return {
        fetchData,
        data: checkInModalData,
        isLoading,
        error,
    };
};
